<template>
  <div class="carousel-container">
    <transition-group name="slide"
                      tag="div"
                      class="carousel">
      <div v-for="slide in activeSlides"
           :key="slide.id || `slide-${currentSlide}`"
           class="carousel-slide"
           :style="{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: slide.background || 'transparent' }"
           @click="slide.clickHandler">
        <img :src="slide.image"
             :style="slide.imageStyle"
             :alt="slide.alt">
        <span v-if="slide.description"
              class="logo-description">{{ slide.description }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  props: {
    slides: {
      type: Array,
      required: true,
      validator: function (value) {
        return value.every((slide) => {
          return slide.id || slide.image || slide.description;
        });
      },
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    interval: {
      type: Number,
      default: 5000,
    },
  },
  computed: {
    activeSlides() {
      // 현재 활성 인덱스의 슬라이드만 반환하여 v-for와 조건 분기를 분리
      return this.slides.filter((_, i) => this.currentSlide === i);
    },
  },
  data() {
    return {
      currentSlide: 0,
      carouselInterval: null,
    };
  },
  mounted() {
    if (this.autoplay) {
      this.startCarousel();
    }
  },
  beforeDestroy() {
    this.stopCarousel();
  },
  methods: {
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        if (this.currentSlide === this.slides.length - 1) {
          this.currentSlide = 0;
        } else {
          this.currentSlide = this.currentSlide + 1;
        }
      }, this.interval);
    },
    stopCarousel() {
      if (this.carouselInterval) {
        clearInterval(this.carouselInterval);
      }
    },
  },
};
</script>

<style scoped>
.carousel-container {
  position: relative;
  width: 100%;
  height: 50px;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  width: 100%;
  height: 100%;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 1.5s ease;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(-100%);
}
</style> 


// WEBPACK FOOTER //
// src/components/shareComponent/Carousel.vue